// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__1Z-7g","label":"CategoryService_label__sxgiL","location":"CategoryService_location__3tf49"};